<div class="container-library">
  <ng-container *ngFor="let qualification of qualifications">
    <div class="library-item">
      <app-qualification-display [qualification]="qualification" (onCLickAction)="onClickItemAction($event, qualification)"></app-qualification-display>
    </div>
  </ng-container>
</div>